export const breadcrumbNameMap = t => {
  return {
    '/cart': t('libraryScreenTranslations:CART'),
    '/upload': t('libraryScreenTranslations:UPLOAD'),
    '/orders': t('libraryScreenTranslations:ORDERS'),
    '/profile': t('libraryScreenTranslations:PROFILE'),
    '/checkout': t('libraryScreenTranslations:CHECKOUT'),
    '/no': t('libraryScreenTranslations:PAGE_NOT_FOUND'),
    '/confirmation': t('libraryScreenTranslations:CONF'),
    '/products': t('libraryScreenTranslations:PRODUCTS'),
    '/billing': t('libraryScreenTranslations:BILLING'),
    '/delivery': t('libraryScreenTranslations:DELIVERY'),
    '/favorite': t('libraryScreenTranslations:FAVS'),
    '/complaint': t('libraryScreenTranslations:COMPLAINT'),
    '/quotations': t('libraryScreenTranslations:QUOTATIONS'),
  };
};
